
import { Component, Mixins, Watch } from 'vue-property-decorator';
import DevApps from '~/components/User/Apps/DevApps.vue';
import EliotApps from '~/components/User/Apps/EliotApps.vue';
import PartnerApps from '~/components/User/Apps/PartnerApps.vue';
import MarketingConsents from '~/components/User/Consents/MarketingConsents/index.vue';
import PartnersConsents from '~/components/User/Consents/PartnersConsents/index.vue';
import FieldsCard from '~/components/User/FieldsCard.vue';
import UserButtons from '~/components/User/UserButtons/UserButtons.vue';
import { UserModule } from '~/store/modules/user';

import MarketingConsentsHistory from '~/components/Popups/User/MarketingConsentsHistory.vue';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import EmailSettings from './EmailSettings.vue';
import GdprConsents from './GDPRConsents.vue';
import UserIdentifiers from './UserIdentifiers.vue';
import FeatureFlags from './FeatureFlags/index.vue';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';

@Component({
    components: {
        MarketingConsentsHistory,
        FieldsCard,
        UserButtons,
        EliotApps,
        PartnerApps,
        DevApps,
        MarketingConsents,
        PartnersConsents,
        FeatureFlags,
        EmailSettings,
        GdprConsents,
        UserIdentifiers,
    },
})

export default class User extends Mixins(UserRightsMixin) {
    get categories() {
        const categories = [
            { title: 'Preferences', fields: UserModule.preferences },
            { title: 'Units', fields: UserModule.units },
        ];
        if (UserModule.userPersonalInformation.length > 0) {
            categories.unshift({ title: 'Administrative', fields: UserModule.userPersonalInformation });
        }
        return categories;
    }

    get corporatesEliot() {
        return UserModule.corporatesEliot;
    }

    get partnerEliot() {
        return UserModule.applicationsEliot;
    }

    get userId() {
        return UserModule.id;
    }

    get partnersApp() {
        return UserModule.applications;
    }

    get devApps() {
        return UserModule.devApplications;
    }

    get isEliot() {
        return UserModule.isEliot;
    }

    get hasPartnersConsents() {
        const brandsConsentsHistory = UserModule.brandsConsentsHistory;
        if (typeof brandsConsentsHistory === 'object') {
            return Object.keys(brandsConsentsHistory).length > 0;
        }
        return false;
    }

    @Watch('userId')
    async fetchPartnersConsents() {
        const isNetatmoUser = UserModule.userType.toLocaleLowerCase() === 'netatmo';
        if (isNetatmoUser && this.isAllowed('TopologyNetatmo', 'getUserConsents')) {
            await UserModule.getUserMarketingsConsents();
            await UserModule.getUserConsents();
        }
        if (this.isAllowed('RemoteFeatureFlagsNetatmo')) {
            await RemoteFeatureFlagsModule.getCurrentUserFlagIds();
        }
    }

    mounted() {
        this.fetchPartnersConsents();
    }
}
